import jwt from 'jwt-simple'
import { scroll } from 'quasar'
import { boot } from 'quasar/wrappers'
import moment from 'moment'
import { i18n } from './i18n'
moment.locale('fr')
const { getScrollTarget, setVerticalScrollPosition } = scroll

let helpers
const { t } = i18n.global

export default boot(({ app, store }) => {
  helpers = {
    stringToDateTime: (sDate) => {
      const date = moment(sDate, moment.ISO_8601)
      if (!date.isValid()) return ''
      return `${date.format('DD/MM/YYYY')} ${t('common.at')} ${date.format(
        'HH:mm'
      )}`
    },
    stringToDate: (sDate) => {
      const date = moment(sDate, moment.ISO_8601)
      if (!date.isValid()) return ''
      return date.format('DD/MM/YYYY')
    },
    stringToDayMonthYear: (sDate) => {
      const date = moment(sDate, moment.ISO_8601)
      if (!date.isValid()) return ''
      return date.format('DD MMM YYYY').toUpperCase()
    },

    refFromUID: (sRef) => {
      let ref = ('000000' + sRef).slice(-6)
      return ref
    },

    removeDuplicates: (myArr, prop) => {
      return myArr.filter((obj, pos, arr) => {
        return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos
      })
    },

    resourcesToFormOptions: (resources) => {
      if (!resources) return [] // NOTE: resources can be undefined, cannot directly try to call .map()
      let uniKeys = [...new Set(resources.map(({ id }) => id))]
      let unics = []
      uniKeys.forEach((key) => {
        unics.push(resources.find((resource) => resource.id === key))
      })
      let options = []
      unics.forEach(function (resource) {
        let option = {
          label: resource.name,
          value: resource.id
        }
        options.push(option)
      })
      return options
    },

    priorityQuasarIdToApiId: (priority) => {
      switch (priority) {
        case -1:
          return 'low'
        case 0:
          return 'normal'
        case 1:
          return 'high'
      }
    },

    priorityApiIdToFrench: (priority) => {
      switch (priority) {
        case 'low':
          return t('createIssue.priorityLow')
        case 'normal':
          return t('createIssue.priorityNormal')
        case 'high':
          return t('createIssue.priorityhigh')
      }
    },

    priorityQuasarIdToFrench: (priority) => {
      switch (priority) {
        case -1:
          return t('createIssue.priorityLow')
        case 0:
          return t('createIssue.priorityNormal')
        case 1:
          return t('createIssue.priorityhigh')
      }
    },

    decodeToken: (token) => {
      if (token !== null && token !== '') {
        let decoded = jwt.decode(token, 'secret', true)
        if (
          decoded !== null &&
          decoded.hasOwnProperty('exp') &&
          new Date(decoded.exp * 1000) >= new Date()
        ) {
          return decoded
        }
      }
      return { sub: null, exp: null, roles: [] }
    },

    isTokenValid: (token) => {
      return new Promise((resolve, reject) => {
        if (token !== null && token.length) {
          let decoded = jwt.decode(token, 'secret', true)
          if (
            decoded !== null &&
            decoded.hasOwnProperty('exp') &&
            new Date(decoded.exp * 1000) >= new Date()
          ) {
            resolve(decoded)
          } else {
            reject(
              app.config.globalProperties.$ErrorHandler.throwSessionExpired(
                '',
                new Error('no Session')
              )
            )
          }
        } else {
          // NOTE: reset all data when token is invalid
          eventBus.$emit('reset')
          reject(
            app.config.globalProperties.$ErrorHandler.throwNoSession(
              '',
              new Error('no Session')
            )
          )
        }
      })
    },

    statusTranslation: (status) => {
      let statuses = {
        pending: {
          color: 'warning',
          label: t('common.helper.statusTranslation.pending'),
          icon: ''
        },
        ongoing: {
          color: 'primary',
          label: t('common.helper.statusTranslation.ongoing'),
          icon: ''
        },
        done: {
          color: 'positive',
          label: t('common.helper.statusTranslation.done'),
          icon: ''
        },
        rejected: {
          color: 'accent',
          label: t('common.helper.statusTranslation.rejected'),
          icon: ''
        }
      }
      return statuses[status]
    },

    statusTaskTranslation: (status) => {
      let statuses = {
        pending: {
          color: 'warning',
          label: t('common.helper.statusTaskTranslation.pending'),
          icon: ''
        },
        ongoing: {
          color: 'primary',
          label: t('common.helper.statusTaskTranslation.ongoing'),
          icon: ''
        },
        failed: {
          color: 'accent',
          label: t('common.helper.statusTaskTranslation.failed'),
          icon: ''
        }
      }
      return statuses[status]
    },

    translatePush: (data) => {
      let msg = JSON.parse(data)
      switch (msg.type) {
        case 'UserConnected': {
          return {
            type: msg.type,
            data: msg.data,
            message: t('common.helper.translatePush.UserConnected.message'),
            detail: t('common.helper.translatePush.UserConnected.detail')
          }
        }
        case 'IssueCreated': {
          return {
            type: msg.type,
            data: msg.data,
            message: t('common.helper.translatePush.IssueCreated.message'),
            detail: t('common.helper.translatePush.IssueCreated.detail', {
              id: msg.data.id
            })
          }
        }
        case 'IssueUpdated': {
          return {
            type: msg.type,
            data: msg.data,
            message: t('common.helper.translatePush.IssueUpdated.message'),
            detail: t('common.helper.translatePush.IssueUpdated.detail', {
              id: msg.data.id
            })
          }
        }
        case 'IssueTalkCreated': {
          return {
            type: msg.type,
            data: msg.data,
            message: t('common.helper.translatePush.IssueTalkCreated.message'),
            detail: t('common.helper.translatePush.IssueTalkCreated.detail', {
              id: msg.data.id
            })
          }
        }
        default: {
          return {
            type: msg.type,
            data: msg.data,
            message: t('common.helper.translatePush.default.message'),
            detail: String(msg.data)
          }
        }
      }
    },

    scrollToElement: (el) => {
      let target = getScrollTarget(el)
      let offset = el.offsetTop - el.scrollHeight
      setVerticalScrollPosition(target, offset, 100)
    },

    findOptionName: (options, id) => {
      return id ? options.find((option) => option.id === id)?.name || '' : ''
    }
  }

  app.config.globalProperties.$helpers = helpers
  app.provide('$helpers', helpers)
})

export { helpers }
